
// Начальный лимит данных
const LIMIT = 2

export default {
  name: 'BaseProfileAuthorExclusive',
  props: {
    author: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      materials: [],
      materialsCount: 0,
    }
  },
  async fetch() {
    if (this.author) {
      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        `/articles/exclusive/${this.author.id}`,
        {
          params: {
            limit: LIMIT,
            offset: 0,
          },
        }
      )

      this.materialsCount = countAllPublishedArticles
      this.materials = articles
    }
  },
  methods: {
    updateMaterial() {
      this.materials = []
      this.$fetch()
    },
  },
}
